import EventBus from "@plugins/common/service/eventbus";

const CommentEventBus = new EventBus();

export default CommentEventBus;
